<template>
	<div
		:class="['back-to-top', {'modify-button-position' : $route.name === 'singleCaseWithDates' || $route.fullPath.includes('?mode=')}]"
		@click="scrollToTop()"
		v-show="showButton && $route.name !== 'submission-new-project-form' && $route.name !== 'submission-continue-draft-project'">
		<img src="@/drc/assets/images/arrow-up.png" alt="Up">
	</div>
</template>
<script>
	import {EventBackToTopButton} from "@/common/configurations/event-bus.js";

	export default {
		name: "BackToTop",
		data() {
			return {
				showButton: false,
				minScrollHeight: 1000
			}
		},
		methods: {
			scrollToTop() {
				this.$parent.$refs.mainContent.scrollTo({
					top: 0,
					left: 0,
					behavior: "smooth",
				});
			}
		},
		mounted() {
			this.$parent.$refs.mainContent.addEventListener("scroll", () => {
				let y = this.$parent.$refs.mainContent.scrollTop;
				this.showButton = y >= this.minScrollHeight ? true : false;
			});

			EventBackToTopButton.$on('toggleButton', () => this.showButton = !this.showButton)
		},
		beforeDestroy() {
			EventBackToTopButton.$off('toggleButton');
		},
		destroyed() {
			if (this.$parent.$refs.mainContent !== undefined) {
				this.$parent.$refs.mainContent.removeEventListener("scroll");
			}
		}
	}
</script>
<style lang="scss">
	@import "@/common/assets/css/_variables.scss";

	.back-to-top {
		position: fixed;
		right: 44px;
		bottom: 110px;
		border: 3px solid rgba(255, 255, 255, 0.6);
		border-radius: 50%;
		cursor: pointer;
		z-index: 10;
		transition: border .4s cubic-bezier(.4,0,.2,1);
		min-width: 40px;
		min-height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;

		@media screen and (max-width: 768px) {
			right: 20px;
		}

		.size-override {
			font-size: 34px !important;
		}

		img {
			width: 19px;
		}

		@media screen and (min-width: 768px) {
			&:hover {
				border: 3px solid rgba(245,178,26,0.6);

				i {
					color: $color-secondary-light !important;
					opacity: 0.9;
				}
			}
		}
	}

	.modify-button-position {
		@media (max-width: $mobile) {
			bottom: 10rem;
		}
	}
</style>
